module.exports.support = {
  vi: {
    title: 'Ủng hộ Avalon · Premium',
    description: 'Ủng hộ chi phí máy chủ và gia hạn tên miền Avalon để nhận Premium.',
    keywords: ['Avalon', 'Premium', 'Ủng hộ', 'Quyên góp'],
  },
  en: {
    title: 'Support Avalon · Premium',
    description: 'Support Avalon hosting and domain renewal and receive Premium.',
    keywords: ['Avalon', 'Premium', 'support', 'donations'],
  },
  ru: {
    title: 'Поддержка Avalon · Premium',
    description: 'Поддержите хостинг и домен Avalon и получите Premium.',
    keywords: ['Avalon', 'Premium', 'поддержка', 'пожертвования'],
  },
  es: {
    title: 'Apoya Avalon · Premium',
    description: 'Apoya el alojamiento y la renovación del dominio de Avalon y recibe Premium.',
    keywords: ['Avalon', 'Premium', 'apoyo', 'donaciones'],
  },
  pt: {
    title: 'Apoie Avalon · Premium',
    description: 'Apoie a hospedagem e a renovação do domínio de Avalon e receba Premium.',
    keywords: ['Avalon', 'Premium', 'apoio', 'doações'],
  },
  'zh-CN': {
    title: '支持 Avalon · Premium',
    description: '支持 Avalon 的服务器托管和域名续费，获得 Premium 身份。',
    keywords: ['Avalon', 'Premium', '支持', '捐赠'],
  },
  'zh-TW': {
    title: '支持 Avalon · Premium',
    description: '支持 Avalon 的伺服器託管和網域續約，獲得 Premium 身分。',
    keywords: ['Avalon', 'Premium', '支持', '捐款'],
  },
};
